var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaCancelModalHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C16.5 4.85787 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85787 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9Z",
    fill: "#D4D7E0",
    stroke: "#09377A",
    strokeWidth: 1.6875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C16.5 4.85787 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85787 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9Z",
    fill: "#E5E7EB",
    stroke: "#6C737F",
    strokeWidth: 1.6875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5625C6 9.5625 7.2 10.2469 7.8 11.25C7.8 11.25 9.6 7.3125 12 6",
    stroke: "#6C737F",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaCancelModalHeaderIcon);
export default __webpack_public_path__ + "static/media/figmaCancelModalHeaderIcon.eeae9bea6cf6c31f318ec77caa52c48f.svg";
export { ForwardRef as ReactComponent };